import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrInsightsListBoxLinkListItemCls: string;
			communityPlsrInsightsListContentSectionHeaderCls: string;
			communityPlsrInsightsListContentSectionTextCls: string;
			communityPlsrInsightsListContentSectionFollowWrapperCls: string;
		}
	},

	slug: string
}

class List extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Insights List Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();

		scroll.registerAnimatedElement(
			this.publicVars.cssId.anim?.communityPlsrInsightsListContentSectionHeaderCls || '',
			'community_plsr_insights_list', { animCls: 'animate__fadeInLeft25P', once: true });
		scroll.registerAnimatedElement(
			this.publicVars.cssId.anim?.communityPlsrInsightsListContentSectionFollowWrapperCls || '',
			'community_plsr_insights_list', { animCls: 'animate__fadeInLeft25P', once: true });
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsListContentSectionTextCls || '',
			'community_plsr_insights_list', { animCls: 'animate__fadeInRight25P', once: true });

		const plsrItemsLength = document.querySelectorAll(
			this.publicVars.cssId.anim?.communityPlsrInsightsListBoxLinkListItemCls || '').length;



		for (let i = 1; i <= plsrItemsLength; i++) {
			scroll.registerAnimatedElement(
				`${this.publicVars.cssId.anim?.communityPlsrInsightsListBoxLinkListItemCls}${i}`,
				'community_plsr_insights_list', { animCls: 'animate__zoomIn50P', once: true });
		}

	}

	bind() {
		this.msg('bind');
	}
}

export default List;